import { Button } from '@payaca/ambrosia';
import { FC, useState } from 'react';
import { useParams } from 'react-router';

import {
  IntegratedEmailProjectActivityEvent,
  ProjectActivityEvent,
} from '../../../gql/graphql';

import SendIntegratedEmailModal from '../sendIntegratedEmailModal/SendIntegratedEmailModal';

import { IntegratedEmailsPermissions } from '@payaca/permissions/integrated-emails/integrated-emails.permissions';
import { IntegratedEmail } from '@payaca/types/integratedEmails';
import { PermissionGuard } from '../permissionGuard/PermissionGuard';

type Props = {
  projectActivityEvent:
    | ProjectActivityEvent
    | IntegratedEmailProjectActivityEvent;
};

const DealActivityEventPrimaryAction: FC<Props> = (props) => {
  const { projectActivityEvent } = props;

  switch (projectActivityEvent.__typename) {
    case 'IntegratedEmailProjectActivityEvent':
      if (projectActivityEvent.type === 'integratedEmailReceived') {
        return (
          <PermissionGuard
            renderIfHasPermissions={[IntegratedEmailsPermissions.SEND_EMAIL]}
          >
            <IntegratedEmailReceivedReply
              integratedEmailId={+projectActivityEvent.integratedEmailId}
            />
          </PermissionGuard>
        );
      }
      return null;
    default:
      return null;
  }
};

const IntegratedEmailReceivedReply = (props: {
  integratedEmailId: IntegratedEmail['id'];
}) => {
  const [isSendEmailModalOpen, setIsSendEmailModalOpen] = useState(false);
  const { projectId } = useParams<{
    projectId: string;
  }>();

  return (
    <>
      <Button
        variant="link"
        className="mr-4"
        onClick={() => {
          setIsSendEmailModalOpen(true);
        }}
      >
        Reply
      </Button>
      <SendIntegratedEmailModal
        onClose={() => setIsSendEmailModalOpen(false)}
        projectId={projectId}
        {...props}
        isOpen={isSendEmailModalOpen}
      />
    </>
  );
};
export default DealActivityEventPrimaryAction;
